import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { NavController,  ModalController } from '@ionic/angular';
import { MyPicsListModel } from '../../providers/user/user';
import { IonicSlides } from '@ionic/angular';
import { Router } from '@angular/router';

/**
 * Generated class for the PictureViewerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
export interface PicturePagerEvent {
  list: MyPicsListModel[]
  index: number,
}
// register();
@Component({
  selector: 'page-picture-viewer',
  templateUrl: 'picture-viewer.html',
  styleUrls:['./picture-viewer.scss']
})
export class PictureViewerPage {


  @Output()
  buttonAction: EventEmitter<any>;
  @Output()
  button1Action: EventEmitter<any>;
  pictures: MyPicsListModel[] = [];
  activeIndex: number;

  @ViewChild("sliderBig")
  sliderBig: any;

  @ViewChild("sliderMini")
  sliderMini: any;
  icon: string;
  icon1: string;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ModalController,
    private router:Router
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};
    console.log(state['emitter1']);
    this.buttonAction = state['emitter'];
    this.button1Action = state['emitter1'];
    this.pictures = state['pictures'];
    this.activeIndex = state['activeIndex'];
    this.icon = state['icon'];
    this.icon1 = state['icon1'];
  }


  ngAfterViewInit() {
    if (this.sliderMini) {
      this.sliderMini.freeMode = true;
    }
    const el = this.sliderBig.nativeElement;
    el.initialize();
  }

  buttonClick() {
    const swiper = this.sliderBig?.nativeElement?.swiper;
    const index = swiper?.activeIndex ?? 0;
    if (this.buttonAction) {
      this.buttonAction.emit({ list: this.pictures, index });
    }
  }

  async button1Click() {
    const swiper = this.sliderBig?.nativeElement?.swiper;
    const index = swiper?.activeIndex ?? 0;
    if (this.button1Action) {
      this.button1Action.emit({ list: this.pictures, index });
    }
    this.dismiss();
  }

  async changeBig() {
    const big = await this.sliderBig?.swiperRef;
    const mini = await this.sliderMini?.swiperRef;

    if (big && mini) {
      const index = big.activeIndex ?? 0;
      mini.slideTo(index);
    }
  }

  async changeMini(index: number) {
    const bigEl = this.sliderBig?.nativeElement;
    const miniEl = this.sliderMini?.nativeElement;
    console.log('index', index)

    const bigSwiper = bigEl?.swiper;
    const miniSwiper = miniEl?.swiper;

    if (bigSwiper && miniSwiper) {
      bigSwiper.slideTo(index);
      this.scrollMiniTo(index); 
    }
  }

  scrollMiniTo(index: number) {
    const swiper = this.sliderMini?.swiperRef;
    if (swiper) {
      swiper.slideTo(index);
    }
  }
  dismiss() {
    this.viewCtrl.dismiss();
  }



}
